import { Alert, Button, Grid, Typography } from "@mui/material";
import { TabHeader } from "./TabHeader";
import { Coin, Coins } from "@phosphor-icons/react";

export default function SupporterShop() {
  const producerBought = false;
  const speedBought = false;
  const moleculeBought = false;
  return (
    <Grid container spacing={2}>
      <TabHeader />
      <Grid item xs={12}>
        <Typography
          variant="h5"
          style={{ color: "lightblue", textAlign: "center", paddingBottom: 8 }}
        >
          Supporter Shop
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <Alert
          severity="info"
          variant="outlined"
          style={{
            width: 500,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            color: "#2196f3",
          }}
        >
          The Game is designed to be played without spending any money. But if
          you want to support the developer and get some little bonuses, you can
          buy some items here. Thank you!
        </Alert>
      </Grid>
      <Grid item xs={12} style={{ paddingBottom: 32 }}>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            paddingRight: 24,
          }}
        >
          <div style={{ paddingRight: 8 }}>You have 0</div>
          <Coin color="yellow" style={{}} size={24} />
        </div>
        <Button
          style={{}}
          onClick={() => {
            //Payment stuff, check if payment is successful and then add coins to database
            console.log("buy coins");
          }}
        >
          <div style={{ paddingRight: 8 }}>Buy</div>
          <Coin size={24} color="yellow" />
        </Button>
      </Grid>
      <Grid item xs={4}>
        <Button
          style={{
            backgroundColor: `rgba(33, 150, 243, ${producerBought ? 1 : 0})`,
            color: "white",
            textTransform: "none",
            width: "250px",
            minWidth: "250px",
            height: "100px",
          }}
        >
          <div>
            <div>Producers are twice as effective</div>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <div style={{ paddingRight: 8 }}>Cost: 35</div>
              <Coin color="yellow" size={20} />
            </div>
          </div>
        </Button>
      </Grid>
      <Grid item xs={4}>
        <Button
          style={{
            backgroundColor: `rgba(33, 150, 243, ${speedBought ? 1 : 0})`,
            color: "white",
            textTransform: "none",
            width: "250px",
            minWidth: "250px",
            height: "100px",
          }}
        >
          <div>
            <div>Producers are 50% faster</div>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <div style={{ paddingRight: 8 }}>Cost: 35</div>
              <Coin color="yellow" size={20} />
            </div>
          </div>
        </Button>
      </Grid>
      <Grid item xs={4}>
        <Button
          style={{
            backgroundColor: `rgba(33, 150, 243, ${moleculeBought ? 1 : 0})`,
            color: "white",
            textTransform: "none",
            width: "250px",
            minWidth: "250px",
            height: "100px",
          }}
        >
          <div>
            <div>You get x2 Molecules</div>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <div style={{ paddingRight: 8 }}>Cost: 60</div>
              <Coin color="yellow" size={20} />
            </div>
          </div>
        </Button>
      </Grid>
    </Grid>
  );
}
